import {
  MOVEMENT_BENEFICIARY_TYPE_NAME,
  MOVEMENT_STATUS_NAME,
  PARTNER_COMPANIES_TYPE_NAME,
  PLAN_TYPE_NAME,
  USER_STATUS_NAME,
  MovementStatusEnum,
  UserStatusEnum,
  COMPANY_STATUS_NAME,
  USER_PROFILE_NAME,
  ReviewsEnum,
  StartDateEnum,
  EndDateEnum,
  OrganizationGroupEnum,
  OPERATION_STATUS_NAME,
} from '../../constants';

enum FilterKeys {
  ORGANIZATIONAL_GROUP = 'organizational-group',
  BENEFICIARIES_TYPE = 'beneficiaries-type',
  STATUS = 'status',
  PLAN_TYPE = 'plan-type',
  START_DATE = 'start-date',
  END_DATE = 'end-date',
  REVIEWS = 'reviews',
  CONTRACT_TYPE = 'contract-type',
  PROFILE = 'profile-id',
  MOVEMENT_STATUS = 'movement-status',
  USER_STATUS = 'user-status',
  OPERATION_STATUS = 'operation-status',
}

const labelMap: Record<FilterKeys, string | {}> = {
  [FilterKeys.REVIEWS]: ReviewsEnum.REVIEWS,
  [FilterKeys.START_DATE]: StartDateEnum.START_DATE,
  [FilterKeys.END_DATE]: EndDateEnum.END_DATE,
  [FilterKeys.ORGANIZATIONAL_GROUP]: OrganizationGroupEnum.ORGANIZATIONAL_GROUP,
  [FilterKeys.BENEFICIARIES_TYPE]: MOVEMENT_BENEFICIARY_TYPE_NAME,
  [FilterKeys.MOVEMENT_STATUS]: MOVEMENT_STATUS_NAME,
  [FilterKeys.USER_STATUS]: USER_STATUS_NAME,
  [FilterKeys.PLAN_TYPE]: PLAN_TYPE_NAME,
  [FilterKeys.CONTRACT_TYPE]: PARTNER_COMPANIES_TYPE_NAME,
  [FilterKeys.STATUS]: COMPANY_STATUS_NAME,
  [FilterKeys.PROFILE]: USER_PROFILE_NAME,
  [FilterKeys.OPERATION_STATUS]: OPERATION_STATUS_NAME,
};

const ignoredFilters = ['searchOrgGroup', 'order-by', 'sort-by', 'page'];

export {
  FilterKeys,
  ignoredFilters,
  labelMap,
  MovementStatusEnum,
  UserStatusEnum,
};
